import React from 'react';
import LineGraph from '../events-line/LineGraph';
import './detail-general-journey-graph.css'


const colors = label => {
  switch (label) {
    case 'Total Horas':
    case 'Total de Horas':
      return '#3b91f6'
    case 'Horas Extras':
    case 'Horas Extras Diurnas':
      return "#f67c00"
    case 'Horas Extras Noturnas':
      return "#8c06d9"
    case 'Horas Extras Contratadas':
      return "#f9d100"
    case 'Banco de Horas':
      return "#cb0e0c"
    case 'Horas Férias':
    case 'Horas em Férias':
      return '#00c9e5'
    default:
      return 'red'
  }
}

const labels = d => {
  let a = []
  d.forEach(element => {
    a.push(element.label.toUpperCase())
  });
  return a
}

const values = d => {
  let a = []
  d.forEach(element => {
    a.push(element.value)
  });
  return a
}

const datasets = data => {
  let datasets = []
  data.forEach(d => {
    datasets.push(
      {
        label: d.title,
        data: values(d.listData),
        fill: true,
        backgroundColor: colors(d.title),
        borderColor: colors(d.title),
      }
    )
  });
  return datasets
}



const DetailGeneralJpurneyGraph = (props) => {
  const data = {
    labels: labels(props.data[0].listData),
    datasets: datasets(props.data),
  }

  return (
    <div className='detail-general-journey-graph-container'>
      <span>Detalhamento Geral da Jornada </span>

      <div className='detail-general-journey-graph'>
        <LineGraph data={data} height='100px' />

      </div>

    </div>
  )

};

export default DetailGeneralJpurneyGraph;